import * as React from 'react';
import './Modal.scss';

import { IoClose } from 'react-icons/lib/io';
import Toast from 'components/Toast';

abstract class ModalElementInterface extends React.Component<{}, { items: Modal[] }> {
  abstract addItem(modal: Modal);
  abstract removeItem(modal: Modal);
}

import { titleCase } from 'change-case';

export type ModalProps = {
  visible: boolean;
  onClose?: (e: React.MouseEvent<HTMLElement>) => any;
  showClose?: boolean;
  large?: boolean;
};

export default class Modal extends React.Component<ModalProps, {}> {

  static Element = class extends ModalElementInterface {
    addItem(modal: Modal) {
      this.setState((state) => {
        state.items.push(modal);
        return state;
      });
    }
    removeItem(modal: Modal) {
      const items = this.state.items;
      const newItems = items.filter((item) => item !== modal);
      // Only bother with updating the state if something changed.
      if (newItems.length !== items.length) {
        this.setState({ items: newItems });
      }
    }
    constructor(props: {}) {
      super(props);
      this.state = {
        items: []
      };
      Modal.instance = this;
    }
    render() {
      const { items } = this.state;
      return (
        <>
        {items.map((item) => {
          const { showClose, onClose, children, visible, large } = item.props;
          return (
            <div className={'modal' + (visible ? ' visible' : '')} key={item.id}>
              <div className={`modal-inner${large ? ' large' : ''}`}>
                {(showClose || (showClose === undefined && onClose)) ?
                  <a href="javascript: void(0);" className="modal-close" onClick={onClose}><IoClose /></a>
                  : null}
                {children}
              </div>
            </div>
          );
        })}
        </>
      );
    }
  };
  private static count: number = 0;
  private static instance: ModalElementInterface;
  /* tslint:disable-next-line */
  component: React.ReactElement<any>;
  id: number = ++Modal.count;
  constructor(props: ModalProps) {
    super(props);
    if (props.visible) Modal.instance.addItem(this);
  }
  componentDidUpdate() {
    Modal.instance.forceUpdate();
  }
  componentWillReceiveProps(newProps: ModalProps) {
    if (!this.props.visible && newProps.visible) {
      Modal.instance.addItem(this);
    }
    if (this.props.visible && !newProps.visible) {
      Modal.instance.removeItem(this);
    }
  }
  render() {
    return null;
  }
  componentWillUnmount() {
    Modal.instance.removeItem(this);
  }
}

/* tslint:disable-next-line */
export class BadRequestHandler extends React.Component<{}, { error: any }> {
  static instance: BadRequestHandler;
  static handler = (reject?: Function) => (error) => {
    if (error.response.data && error.response.data.errors)
      BadRequestHandler.instance.setState({ error: error.response.data.errors });
    else if (error.response.data && error.response.data.message)
      Toast.throw({ message: error.response.data.message });
    else
      Toast.throw({ message: error.message });
    if (reject) reject(error);
  }
  constructor(props: {}) {
    super(props);
    this.state = {
      error: null
    };
    BadRequestHandler.instance = this;
  }
  close = () => {
    this.setState({ error: null });
  }
  render() {
    const { error } = this.state;
    return (
      <Modal visible={error} onClose={this.close}>
        {error ? <>
          <h3>There was an error</h3>
          {(Array.isArray(error) && error[0].constraints) ? <ul>
            {error.reduce((acc, { constraints, property }) =>
              acc.concat(Object.keys(constraints).map(key => ({
                key: property + key,
                message: constraints[key].replace(new RegExp(property, 'g'), titleCase(property))
              }))), [])
              .map(err => <li key={err.key}>{err.message}</li>)}
          </ul> : null}
          </> : null}
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Modal/index.tsx